import { ArrowRight, BookOpenText, Info } from 'lucide-react'
import CategoryIcon from './CategoryIcon.jsx'

function historicalHighlights(categories) {
  const priority = [
    ['length', 'arshin-tailor'],
    ['mass', 'oka'],
    ['volume', 'vedro'],
    ['area', 'dyulyum'],
    ['length', 'roman-foot'],
    ['length', 'byzantine-foot'],
  ]

  return priority.map(([categoryId, unitId]) => {
    const category = categories.find((item) => item.id === categoryId)
    const unit = category.units.find((item) => item.id === unitId)
    return { category, unit }
  })
}

export default function HistoricalSection({ locale, copy, categories, note, onUseUnit, onReadFullHistory }) {
  const highlights = historicalHighlights(categories)
  return (
    <section className="historical-section" id="historical" aria-labelledby="historical-title">
      <div className="section-heading historical-heading">
        <div>
          <div className="historical-title-line">
            <span className="bulgarian-flag" aria-hidden="true"><i /><i /><i /></span>
            <h2 id="historical-title">{copy.historicalTitle} <span className="history-label">his</span></h2>
          </div>
          <p>{copy.historicalIntro}</p>
        </div>
        <div className="historical-heading-actions">
          <p className="historical-note"><Info aria-hidden="true" size={17} /> {note}</p>
          <button type="button" className="historical-story-link" onClick={onReadFullHistory}><BookOpenText aria-hidden="true" size={17} /> {copy.readFullHistory}</button>
        </div>
      </div>

      <div className="historical-grid">
        {highlights.map(({ category, unit }) => {
          const metricUnit = category.units.find((item) => item.id === category.baseUnit)
            ?? category.units.find((item) => item.system === 'metric')
          return <article className="historical-card" key={unit.id}>
            <div className="history-icon"><CategoryIcon categoryId={category.id} size={25} /></div>
            <div className="historical-card-copy">
              <h3>{unit.name} <span className="history-label">his</span></h3>
              <p className="bulgarian-name" lang={locale === 'bg' ? 'en' : 'bg'}>{locale === 'bg' ? unit.nameEn : unit.bulgarianName}</p>
              <dl className="history-meta">
                <div><dt>{copy.group}</dt><dd>{category.name}</dd></div>
                <div><dt>{copy.activeUse}</dt><dd>{unit.period}</dd></div>
              </dl>
              <p>{unit.description}</p>
              <p className="history-origin"><strong>{copy.originStory}</strong>{unit.localizedEtymology ?? unit.etymology}</p>
              <button type="button" onClick={() => onUseUnit(category.id, unit.id)}>
                {copy.compareWith} {metricUnit.name} <ArrowRight aria-hidden="true" size={16} />
              </button>
            </div>
          </article>
        })}
      </div>
    </section>
  )
}
